module.exports = __webpack_public_path__ + "img/changelog-preview.a23ae306.png";